import React from 'react';
import { Section } from '../../../components/ui/Section';
import InfoRow from '../../../components/ui/InfoRow';

interface MeExtended { id: string; email: string; name: string; role: string; hasGoogleCalendar: boolean; hasPersonalGoogleCalendar: boolean; personalCalendarToken?: string | null; avatarUrl?: string | null; }

export default function InfoAppSection({ user }: { user?: MeExtended }) {
  return (
    <Section title="Informazioni applicazione" collapsible defaultOpen={false}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <InfoRow label="Versione" value={`v${__APP_VERSION__}`} highlight />
        <InfoRow label="Ruolo" value={user?.role ?? '—'} />
        <InfoRow label="Account" value={user?.email ?? '—'} />
        <div style={{ marginTop: '0.5rem', paddingTop: '0.75rem', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)', lineHeight: 1.6 }}>
            LensCRM — CRM per fotografi cerimoniali.<br />
            Stack: Node.js 20 · Fastify 4 · React 18 · PostgreSQL 16
          </p>
          <a
            href="https://github.com/OLife97/lenscrm/blob/main/STATO_LAVORI.md"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 'var(--text-xs)', color: 'var(--color-primary)', textDecoration: 'none', marginTop: '0.25rem', display: 'inline-block' }}
          >
            Vedi changelog
          </a>
        </div>
      </div>
    </Section>
  );
}
